var hashtag_default = {
  "fontElementMap": "YBw7W",
  "hashtag": "LNwV7"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
